@if (company) {
  <div class="main-div add-company-page" [formGroup]="company">
    <div class="page-heading">
      <h2 class="fw-bold mb-0">Add Company</h2>
    </div>
    <div class="add-company-scroll-body">
      @if (isCompanyExist) {
        <div class="alert alert-danger alert-dismissible fade show" role="alert">
          Company <strong>{{company.value.Name}}</strong> is already exists.
          <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"
          (click)="ResetExistValue()"></button>
        </div>
      }
      @if (isCompanySucess) {
        <div class="alert alert-success alert-dismissible fade show" role="alert">
          Company has been added sucessfully.
          <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"
          (click)="ResetSuccessValue()"></button>
        </div>
      }
      @if (isCompanyFailure) {
        <div class="alert alert-danger alert-dismissible fade show" role="alert">
          Company has not added sucessfully.
          <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"
          (click)="ResetFailureValue()"></button>
        </div>
      }
      @if (isCompanyUpdate) {
        <div class="alert alert-success alert-dismissible fade show" role="alert">
          Company has been updated sucessfully.
          <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"
          (click)="ResetSuccessValue()"></button>
        </div>
      }
      <div class="field-sets">
        <div class="col-12 col-sm-12 field row">
          <div class="col-sm-4">
            <div class="row">
              <div class="col-sm-4 label-form">
                <label class="required-field">Name*</label>
              </div>
              <div class="col-sm-8">
                <input type="text" formControlName="Name" class="form-control form-control-sm">
                @if (showCompanyNameError) {
                  <span style="color:var(--oranges--orange-600)">**Please Enter Name..</span>
                }
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="row">
              <div class="col-sm-4 label-form">
                <label>Street Line 1</label>
              </div>
              <div class="col-sm-8">
                <input type="text" formControlName="StreetLine1" class="form-control form-control-sm">
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="row">
              <div class="col-sm-4 label-form">
                <label>Street Line 2</label>
              </div>
              <div class="col-sm-8">
                <input type="text" formControlName="StreetLine2" class="form-control form-control-sm">
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-12 field row">
          <div class="col-sm-4">
            <div class="row">
              <div class="col-sm-4 label-form">
                <label>City</label>
              </div>
              <div class="col-sm-8">
                <input type="text" formControlName="City" class="form-control form-control-sm">
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="row">
              <div class="col-sm-4 label-form">
                <label>State</label>
              </div>
              <div class="col-sm-8">
                <p-select
                  placeholder="Select State.."
                  formControlName="State"
                  [options]="states"
                  optionLabel="value"
                  optionValue="key"
                  [showClear]="true"
                  [filter]="true"
                  filterBy="value"
                  panelStyleClass="figma-add-item-select-panel"
                  scrollHeight="213px"
                  styleClass="w-100 figma-field-select p-select--plain"
                  [appendTo]="'body'"
                />
                @if (showCompanyStateError) {
                  <span style="color:var(--oranges--orange-600)">**Please Select State..</span>
                }
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="row">
              <div class="col-sm-4 label-form">
                <label>Pin Number</label>
              </div>
              <div class="col-sm-8">
                <input type="text" formControlName="PinNumber" class="form-control form-control-sm">
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-12 field row">
          <div class="col-sm-4">
            <div class="row">
              <div class="col-sm-4 label-form">
                <label>Phone No.</label>
              </div>
              <div class="col-sm-8">
                <input type="text" formControlName="PhoneNumber" class="form-control form-control-sm">
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="row">
              <div class="col-sm-4 label-form">
                <label>Mobile No.</label>
              </div>
              <div class="col-sm-8">
                <input type="text" formControlName="MobileNumber" class="form-control form-control-sm">
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="row">
              <div class="col-sm-4 label-form">
                <label>Email</label>
              </div>
              <div class="col-sm-8">
                <input type="text" formControlName="Email" class="form-control form-control-sm">
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-12 field row">
          <div class="col-sm-4">
            <div class="row">
              <div class="col-sm-4 label-form">
                <label>Fax</label>
              </div>
              <div class="col-sm-8">
                <input type="text" formControlName="Fax" class="form-control form-control-sm">
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="row">
              <div class="col-sm-4 label-form">
                <label>PanNo</label>
              </div>
              <div class="col-sm-8">
                <input type="text" formControlName="PanNumber" class="form-control form-control-sm">
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="row">
              <div class="col-sm-4 label-form">
                <label>FY Start Date</label>
              </div>
              <div class="col-sm-8">
                <asq-figma-date-input
                  #fyDate
                  formControlName="FyStartDate"
                  shellClass="figma-add-company__fy-datepicker p-datepicker w-100"
                  styleClass="figma-item-d2014__date-input"
                  (dateFocused)="SetDate()"
                  (dateCommitted)="ConvertToDate()" />
                @if (showCompanyFYStartDateError) {
                  <span style="color:var(--oranges--orange-600)">**Please Enter FY Start Date..</span>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tax-div settings-figma-section-card">
        <div class="figma-section-header">
          <h3 class="figma-section-title">GST Information</h3>
        </div>
        <div class="figma-section-divider" aria-hidden="true"></div>
        <div class="col-12 col-sm-12 field row">
          <div class="col-sm-4">
            <div class="row">
              <div class="col-sm-4 label-form">
                <label>Enable GST</label>
              </div>
              <div class="col-sm-8">
                <p-select
                  formControlName="EnableGST"
                  [options]="ynOptions"
                  optionLabel="label"
                  optionValue="value"
                  panelStyleClass="figma-add-item-select-panel"
                  scrollHeight="213px"
                  styleClass="w-100 figma-field-select p-select--plain"
                  [appendTo]="'body'"
                  (onChange)="ShowCessAndDealer()"
                />
              </div>
            </div>
          </div>
          @if (showCessAndDealer) {
            <div class="col-sm-4">
              <div class="row">
                <div class="col-sm-4 label-form">
                  <label>Enable Cess</label>
                </div>
                <div class="col-sm-8 row pe-sm-0">
                  <div class="col-sm-4">
                    <select formControlName="EnableCess" class="form-control form-control-sm" (change)="ShowCaption()">
                      <option value="N">N</option>
                      <option value="Y">Y</option>
                    </select>
                  </div>
                  @if (showCaption) {
                    <div class="col-sm-8 ps-sm-0 pe-sm-0">
                      <input type="text" formControlName="Caption" placeholder="Caption" class="form-control form-control-sm">
                    </div>
                  }
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="row">
                <div class="col-sm-4 label-form">
                  <label>Type Of Dealer</label>
                </div>
                <div class="col-sm-8">
                  <p-select
                    formControlName="TypeOfDealer"
                    [options]="dealerTypeOptions"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Select Dealer"
                    (onChange)="ShowGstin()"
                    panelStyleClass="figma-add-item-select-panel"
                    scrollHeight="213px"
                    styleClass="w-100 figma-field-select p-select--plain"
                    [appendTo]="'body'"
                  />
                </div>
              </div>
            </div>
          }
        </div>
        @if (showGstin) {
          <div class="col-12 col-sm-12 field row">
            <div class="col-sm-4">
              <div class="row">
                <div class="col-sm-4 label-form">
                  <label>GSTIN</label>
                </div>
                <div class="col-sm-8">
                  <input type="text" formControlName="GSTIN" class="form-control form-control-sm">
                </div>
              </div>
            </div>
          </div>
        }
      </div>
      @if (isLimitReachedErr) {
        <div class="add-company-limit-msg">
          <span style="color:var(--oranges--orange-600);">Allocated company credit is over. For adding more companies, Please Upgrade Your Package.</span>
        </div>
      }
    </div>
    <div class="buttons-container">
      <button type="button" class="secondary-button" (click)="redirectToHome()">Close</button>
      <button type="button" class="primary-button" (click)="SaveNewCompany()">Save</button>
    </div>
  </div>
}
